import * as React from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import Icon from './Icon';

interface ChangeIndicator {
    theme?: { [property: string]: string | number };
    value: string | number;
}

const iconStyleProps = {
    display: "inline-block",
    verticalAlign: "middle"
};

export const ChangeIndicator: React.SFC<ChangeIndicator> = ({ theme, value }) => {
    // Depending on format codes used values maybe a string or number, e.g. "-4.2%" or -4.2
    // So if the value is not a number strip of any non-numeric characters (except "." & "-") then parseFloat.
    let valueAsNumber = isNaN(value as number) ? parseFloat(`${value}`.replace(/[^0-9.-]/g, '')) : value;

    if (valueAsNumber > 0) {
        return (
            <Icon fileName="ChangeUpIcon" {...iconStyleProps} {...theme.ChangeUpIcon} />
        );
    }
    if (valueAsNumber < 0) {
        return (
            <Icon fileName="ChangeDownIcon" {...iconStyleProps} {...theme.ChangeDownIcon} />
        );
    }
    return (
        <Icon fileName="NoChangeIcon" {...iconStyleProps} {...theme.NoChangeIcon} />
    );
};

export default observer(withTheme(ChangeIndicator));


// WEBPACK FOOTER //
// ./src/Components/ChangeIndicator.tsx